//#region  import
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { locationApi } from '../../../../services/apis';
import { serverAddress } from '../../../../utils/consts/server';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Toast } from '../../../common';
import {
  LocationIcon,
  SyncIcon,
  ChevronDownIcon,
  CloseIcon,
  AirplaneIcon,
} from '~svg';
import axios from 'axios';
import './selectAirport.scss';

//#endregion
let localAirportList = {};
class SelectAirport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allAirport: {},
      localAirport: {},
      fromAirport: {},
      toAirport: {},
      indexOfOption: 0,
      indexOfOptionChild: -1,
      to: '',
      from: '',
      toCountryName: '',
      fromCountryName: '',
      currentType: 'from',
      isLocal: true,
      isFocused: false,
      isHovered: false,
      isFocusedTo: false,
      isHoveredTo: false,
      openToast: false,
    };
  }
  // #region Lifecycle
  componentDidMount() {
    //fech api to get all airport list
    this.getAirPort();
    const { origin, destination } = this.props.data,
      { focus } = this.props;
    //get selected airport from sessionStorage and set to state
    if (origin?.city && destination?.city)
      this.updateStateFromSessionStorage(origin, destination);
    // if back to this page from next pages focus on specific element
    if (focus) {
      try {
        document.getElementById(focus).focus();
        document.getElementById(focus).select();
      } catch {}
    }
  }
  //set origin and destination on will receive props
  UNSAFE_componentWillReceiveProps(nextprops) {
    const { origin, destination } = nextprops.data;
    if (origin && destination)
      this.updateStateFromSessionStorage(origin, destination);
  }
  //#endregion

  //#region  Call API
  //get popular airport at first and show them
  getAirPort = () => {
    locationApi
      .getPopularAirport()
      .then((result) => {
        if (result?.status === 200) {
          localAirportList = result?.payload?.data;
          this.setState({
            localAirport: result?.payload?.data,
          });
        }
      })
      .catch((error) => console.log('error', error));
  };
  // search on all airport
  searchAirport = (selectValue, type) => {
    let route = `airport/search`,
      url = `${serverAddress}/${route}`;
    // cancel the previous request
    if (typeof this._source != typeof undefined) {
      this._source.cancel('Operation canceled due to new request.');
    }
    // save the new request for cancellation
    this._source = axios.CancelToken.source();
    axios
      .post(
        url,
        { phrase: selectValue.toLowerCase() },
        // cancel token used by axios
        { cancelToken: this._source.token },
      )
      .then((response) => {
        if (response.status === 200)
          this.setState((state) => {
            state.allAirport = response.data.payload.data;
            state.isLocal = false;
            if (type === 'from') {
              state.isFocused = false;
              state.isHovered = true;
              state.indexOfOption = 0;
            }
            if (type === 'to') {
              state.isFocusedTo = false;
              state.isHoveredTo = true;
            }
            return state;
          });
      })
      .catch((error) => {
        console.log('errror', error);
      });
  };
  //#endregion
  //#region  Usefull functions
  makeAirportInformation = (item, locationCode) => {
    const {
      language: { name },
      intl,
    } = this.props;
    return item.isLocal || locationCode
      ? `${item?.locationName?.[name]},${
          item?.countryName?.[name]
        }${intl.formatMessage({ id: 'booking.allairport' })}`
      : `${item?.locationName?.[name]},${item?.countryName?.[name]}(${item?.name?.[name]})`;
  };
  //get selected item and set all usefull data and show selected airport in text of option list
  selectCity = (item, locationCode, type) => {
    const selectedAirport = JSON.parse(
      sessionStorage.getItem('selectedAirport'),
    );
    const {
      language: { name },
      index,
    } = this.props;
    if (locationCode) item.iata = locationCode;
    let selectedCity = {},
      isInternational = item.isInternational
        ? true
        : item?.countryName?.['en']?.includes('Iran')
        ? false
        : true;
    selectedCity = {
      city: item,
      locationCode: locationCode
        ? locationCode
        : item.isPopular
        ? item.locationCode
        : null,
      isInternational,
      isLocation: locationCode || item?.isPopular ? true : false,
      countryCode: item?.countryCode,
    };
    if (
      (type === 'to' &&
        selectedAirport?.[index]?.origin?.city?.locationName?.[name] ===
          selectedCity?.city?.locationName?.[name]) ||
      (type === 'from' &&
        selectedAirport?.[index]?.destination?.city?.locationName?.[name] ===
          selectedCity?.city?.locationName?.[name])
    ) {
      this.setState({ openToast: true });
    } else {
      this.setState(
        (state) => {
          state[`isFocused${type === 'to' ? 'To' : ''}`] = false;
          state[`isHovered${type === 'to' ? 'To' : ''}`] = false;
          state[`${type}Airport`] = item;
          state[`${type}`] = this.makeAirportInformation(item, locationCode);
          return state;
        },
        () => {
          type === 'to'
            ? this.toggleSelectTo(null, 'to')
            : this.toggleSelect(null, 'from');

          this?.props?.refreshData(selectedCity, type);
        },
      );
    }
  };

  //get selected airport from sessionStorage and set to state
  updateStateFromSessionStorage = (origin, destination) => {
    let {
      language: { name },
      intl,
    } = this.props;

    this.setState((state) => {
      if (origin.city) {
        let { city, isLocation } = origin;
        state.fromAirport = city;
        state.from =
          isLocation === true
            ? `${city.locationName[name]} , ${
                city?.countryName[name]
              }${intl.formatMessage({ id: 'booking.allairport' })}`
            : ` ${city?.locationName[name]} , ${
                city?.countryName?.[name] || ''
              } ( ${city?.name?.[name]} )`;
      }
      if (destination.city) {
        const { city, isLocation } = destination;
        state.toAirport = city;
        state.to =
          isLocation === true
            ? `${city?.locationName?.[name]} , ${
                city?.countryName?.[name]
              }${this.props.intl.formatMessage({ id: 'booking.allairport' })}`
            : ` ${city?.locationName?.[name]} , ${
                city?.countryName?.[name] || ''
              } ( ${city?.name?.[name]} ) `;
      }
      return state;
    });
  };

  //change origin and destination airport (swap)
  changeAirport = () => {
    const { index, swapAirport } = this.props;
    if (swapAirport) swapAirport(index);
  };
  //select input
  selectText = (inputName) => {
    document.getElementById(inputName).select();
  };
  gotoNextAirport = (type) => {
    let { from, isFocused, isHovered } = this.state;
    let { destinationCity, index } = this.props;
    if (
      type === 'from' &&
      from.length &&
      isFocused === false &&
      isHovered === false &&
      !destinationCity
    ) {
      this.setState({ currentType: 'to' });

      document.getElementById(`inputbooking.to${index}`).focus();
      document.getElementById(`inputbooking.to${index}`).click();
    }
  };
  //#endregion
  //#region  Handel changes
  selectCurrentInput = ({ id }) => {
    try {
      document.getElementById(id).select();
    } catch {}
  };
  //set destination on state after select each airport
  toggleSelectTo = (value, type) => {
    if (value) {
      this.setState({
        currentType: 'to',
        isFocusedTo: true,
        isHoveredTo: true,
        indexOfOption: 0,
      });
    } else if (value === false)
      setTimeout(() => {
        this.setState({
          currentType: 'to',
          isFocusedTo: false,
          indexOfOption: 0,
        });
      }, 250);
    else
      this.setState({
        currentType: 'from',
        isFocusedTo: false,
        isHoveredTo: false,
        indexOfOption: 0,
      });
  };
  handleChange = (event, type) => {
    let selectValue = event.target.value;
    const { refreshData } = this.props;

    if (selectValue.length >= 1) this.searchAirport(selectValue, type);
    else this.setState({ localAirport: localAirportList });
    if (type === 'to') {
      this.setState(
        {
          isLocal: selectValue.length === 0 ? true : false,
          to: selectValue,
          currentType: 'to',
        },
        () => {
          if (refreshData) refreshData(selectValue, 'to');
        },
      );
    } else {
      this.setState(
        {
          isLocal: selectValue.length === 0 ? true : false,
          from: selectValue,
          currentType: 'false',
        },
        () => {
          if (refreshData) {
            refreshData(selectValue, 'from');
          }
        },
      );
    }
  };
  //set origin on state after select each airport
  toggleSelect = (value, type) => {
    if (value) {
      this.setState(
        {
          currentType: 'from',
          isFocused: true,
          isHovered: true,
          indexOfOption: 0,
          isLocal: true,
        },
        () => {
          //  go to destination airport if select origin airport
          this.gotoNextAirport(this.state.currentType);
        },
      );
    } else if (value === false)
      setTimeout(() => {
        this.setState(
          {
            isFocused: false,
            currentType: 'from',
            indexOfOption: 0,
            isLocal: true,
          },
          () => {
            this.gotoNextAirport(type);
          },
        );
      }, 250);
    else {
      this.setState(
        {
          isFocused: false,
          isHovered: false,
          currentType: 'from',
          indexOfOption: 0,
        },
        () => {
          this.gotoNextAirport(type);
        },
      );
    }
  };

  handleSelectCity = (type, item) => {
    const { from, to } = this.state;
    const { name } = this.props.language;
    let originCity = from.split(',', 1)[0].replace(' ', '');
    let destinationCity = to.split(',', 1)[0].replace(' ', '');

    if (
      !(
        (type == 'to' && originCity == item.name[name]) ||
        (type == 'from' && destinationCity == item.name[name])
      )
    ) {
      this.selectCity(item, null, type);
    } else {
      this.setState({ openToast: true });
    }
  };
  //#endregion
  //#region  Render

  renderInternationalAirportInput = (label, type, placeholder) => {
    let {
      flightType,
      index,
      language: { direction },
    } = this.props;
    let {
        from,
        to,
        isFocused,
        isFocusedTo,
        indexOfOption,
        allAirport,
        localAirport,
        isLocal,
        indexOfOptionChild,
      } = this.state,
      inputId = `input${label}${index}`;
    return (
      <input
        id={inputId}
        autoComplete="off"
        onBlur={() => {
          type === 'from'
            ? this.toggleSelect(false, type)
            : this.toggleSelectTo(false, type);
        }}
        type="text"
        style={{ textAlign: 'Start' }}
        className={`bookflight-typeahead p-0 py-1 py-md-0 d-flex text-captalize ${
          flightType == 'multicity' ? 'multicity' : 'oneWay'
        } w-100`}
        value={type === 'to' ? to : from}
        placeholder={placeholder}
        onFocus={() => this.selectText(inputId)}
        onChange={(event) => this.handleChange(event, type)}
        onKeyDown={(e) => {
          let optionsDiv = document.getElementById('optionList');
          let checkType = type === 'from' ? isFocused : isFocusedTo;
          if (!isLocal) {
            if (
              e.keyCode === 40 &&
              (indexOfOption < Object.keys(allAirport).length - 1 ||
                indexOfOptionChild <
                  allAirport[Object.keys(allAirport)[indexOfOption]].length - 1)
            ) {
              if (
                allAirport[Object.keys(allAirport)[indexOfOption]].length > 0
              ) {
                if (
                  indexOfOptionChild <
                  allAirport[Object.keys(allAirport)[indexOfOption]].length
                ) {
                  if (
                    indexOfOptionChild ===
                    allAirport[Object.keys(allAirport)[indexOfOption]].length -
                      1
                  ) {
                    this.setState(
                      {
                        indexOfOptionChild: -1,
                        indexOfOption: indexOfOption + 1,
                      },
                      () => {
                        if (indexOfOption > 1) optionsDiv.scrollTop += 39;
                      },
                    );
                  } else
                    this.setState(
                      {
                        indexOfOptionChild: indexOfOptionChild + 1,
                      },
                      () => {
                        if (indexOfOption > 1) optionsDiv.scrollTop += 39;
                      },
                    );
                } else
                  this.setState({
                    indexOfOptionChild: null,
                    indexOfOption: indexOfOption + 1,
                  });
              }
            } else if (e.keyCode === 13) {
              //is child
              if (indexOfOptionChild !== -1) {
                this.selectCity(
                  allAirport[Object.keys(allAirport)[indexOfOption]][
                    indexOfOptionChild
                  ],
                  null,
                  type,
                );
              }
              //is parent
              else
                this.selectCity(
                  allAirport[Object.keys(allAirport)[indexOfOption]][0],
                  Object.keys(allAirport)[indexOfOption],
                  type,
                );
            } else if (
              e.keyCode === 38 &&
              (indexOfOption > 0 || indexOfOptionChild !== -1)
            ) {
              if (indexOfOptionChild === -1) {
                this.setState(
                  {
                    indexOfOption: indexOfOption - 1,
                  },
                  () => {
                    this.setState({
                      indexOfOptionChild:
                        allAirport[Object.keys(allAirport)[indexOfOption]]
                          .length - 1,
                    });
                  },
                );
              } else {
                if (
                  indexOfOptionChild <
                  allAirport[Object.keys(allAirport)[indexOfOption]].length
                )
                  this.setState({
                    indexOfOptionChild: indexOfOptionChild - 1,
                  });
              }
              optionsDiv.scrollTop -= 39;
            }
          } else {
            if (!checkType && (e.keyCode === 13 || e.keyCode === 40))
              type === 'from'
                ? this.toggleSelect(true, type)
                : this.toggleSelectTo(true, type);
            else if (
              checkType === true &&
              e.keyCode === 40 &&
              indexOfOption < localAirport.length - 1
            ) {
              this.setState({ indexOfOption: indexOfOption + 1 }, () => {
                if (indexOfOption > 4) optionsDiv.scrollTop += 39;
              });
            } else if (checkType === true && e.keyCode === 13) {
              this.selectCity(localAirport[indexOfOption], null, type);
            } else if (
              checkType === true &&
              e.keyCode === 38 &&
              indexOfOption > 0
            )
              this.setState({ indexOfOption: indexOfOption - 1 }, () => {
                optionsDiv.scrollTop -= 39;
              });
          }
        }}
      />
    );
  };
  renderList = (type) => {
    let { flightType, language } = this.props;
    const { isFocused, isHovered, isFocusedTo, isHoveredTo, allAirport } =
      this.state;
    if (
      (type === 'from' && (isFocused || isHovered)) ||
      (type === 'to' && (isFocusedTo || isHoveredTo))
    )
      return (
        <div
          className={`w-100 position-absolute shadow bookflight-peoplepicker 
          ${language.direction} default-border-bottom-radius-xsmall
          ${flightType} ${type} border-third  bg-third-light   border border-top-0 
          ${
            flightType == 'multicity'
              ? `default-border-${
                  language.direction == 'rtl'
                    ? type == 'to'
                      ? 'right'
                      : 'left'
                    : type == 'to'
                    ? 'left'
                    : 'right'
                }-radius-xsmall`
              : ''
          }`}
          style={{
            right: 0,
            top: flightType == 'multicity' ? '78%' : '81%',
          }}
          // onMouseLeave={() => {
          //   this.setState({
          //     isFocused: false,
          //     isHovered: false,
          //     isFocusedTo: false,
          //     isHoveredTo: false,
          //   });
          // }}
        >
          <ul
            className=" citypicker m-2 rounded bg-third-light"
            id="optionList"
          >
            {this.renderCity(type)}
            {allAirport &&
              allAirport.length === 0 &&
              (isFocused || isHovered) && (
                <div className="number-picker d-flex font-weight-bold text-muted">
                  <FormattedMessage id="booking.notfound" />
                </div>
              )}
          </ul>
        </div>
      );
  };
  renderCity = (type) => {
    let { allAirport, isLocal, indexOfOption, indexOfOptionChild, from, to } =
      this.state;
    let { name } = this.props.language;
    let { flightType } = this.props;
    if (isLocal) {
      return this.renderLocalAirport(type);
    } else {
      if (allAirport)
        return Object.keys(allAirport).map((keys, airPortIndex) => {
          let originCity = from
            ? from.search(allAirport[keys][0].locationName[name])
            : -1;

          return (
            keys.length === 3 && (
              <div
                id={`allAirport-${type}-${keys}`}
                name={`allAirport-${type}-${keys}`}
                key={`allAirport-${type}-${keys}`}
                className="text-nowrap"
                style={{ minWidth: 180 }}
              >
                <div
                  style={{ borderBottom: '1px solid #eee' }}
                  className={`
                  ${flightType == 'multicity' ? 'font-smaller' : ''}
                  ${
                    indexOfOptionChild === -1 &&
                    airPortIndex === indexOfOption &&
                    'dropDownComponentHover'
                  }`}
                >
                  <div
                    className="cursor-pointer p-2 d-flex align-items-center justify-content-start"
                    onClick={() => {
                      originCity == -1
                        ? this.selectCity(allAirport[keys][0], keys, type)
                        : this.setState({ openToast: true });
                    }}
                  >
                    <LocationIcon
                      color="#aaacaf"
                      size={flightType == 'multicity' ? 12 : 16}
                    />
                    <span
                      className={`${
                        name === 'fa' ? 'pr-2' : 'pl-2'
                      } city-title font-weight-bold text-secondary`}
                    >
                      {`${allAirport[keys][0].locationName[name]},`}&nbsp;
                    </span>
                    <span className="city-title text-third">
                      {`${allAirport[keys][0].countryName[name]} `}
                    </span>
                    &nbsp;
                    <span className="airport-title font-weight-bold text-third pt-1">
                      <FormattedMessage id="booking.allairport" />
                    </span>
                  </div>
                </div>
                {allAirport[keys].map((item, index) => {
                  let { name } = this.props.language;
                  return (
                    <li
                      id={`airport-${index}`}
                      name={`airport-${index}`}
                      key={`airport-${index}`}
                      onClick={() => {
                        originCity == -1
                          ? this.selectCity(item, null, type)
                          : this.setState({ openToast: true });
                      }}
                      className={`
                      ${
                        flightType == 'multicity'
                          ? 'font-smaller'
                          : 'font-small'
                      }
                      ${
                        airPortIndex.toString().concat('.' + index) ===
                          indexOfOption
                            .toString()
                            .concat('.' + indexOfOptionChild) &&
                        'dropDownComponentHover'
                      }`}
                    >
                      <div
                        className={
                          'd-flex align-items-center justify-content-center airport'
                        }
                      >
                        <div
                          className="p-2 d-flex flex-start col-11"
                          style={{ borderBottom: '1px solid #eee' }}
                        >
                          <div className={`${name === 'en' ? 'pl-3' : 'pr-2'}`}>
                            <AirplaneIcon
                              color={'#aaacaf'}
                              size={flightType == 'multicity' ? 12 : 16}
                              variant="rotateAirplane"
                            />

                            <span
                              className={`${
                                name === 'fa' ? 'pr-2' : 'pl-1'
                              } font-weight-bold  
                          city-note text-third`}
                            >
                              {`${item.iata},  `}
                            </span>
                            <span className="city-title font-weight-bold ">
                              {`${item.name[name]}`}
                            </span>
                            <span className="city-title   text-third">
                              {`, ${item.countryName[name]}`}
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </div>
            )
          );
        });
    }
  };
  renderLocalAirport = (type) => {
    let { localAirport, isLocal, indexOfOption, from, to } = this.state;
    let { name } = this.props.language;
    let originCity = from.split(',', 1)[0].replace(' ', '');
    let destinationCity = to.split(',', 1)[0].replace(' ', '');

    if (isLocal)
      return (
        <ul key="loacl" className="favCityPicker d-flex py-1 flex-wrap px-0">
          {localAirport?.length &&
            localAirport?.map((item, index) => {
              const isSameAirport =
                (type == 'to' && originCity == item.name[name]) ||
                (type == 'from' && destinationCity == item.name[name]);
              return (
                <li
                  key={`localAirport-${index}`}
                  id={`localAirport-${index}`}
                  name={`localAirport-${index}`}
                  onClick={() =>
                    isSameAirport ? null : this.handleSelectCity(type, item)
                  }
                  onMouseEnter={() => this.setState({ indexOfOption: index })}
                  className={`${
                    index === indexOfOption && ''
                  }  col-3 col-sm-4 col-xxl-3 d-inline-block  p-0 mb-2 overflow-hidden `}
                >
                  <div className="w-100 d-flex align-items-center justify-content-center">
                    <div
                      className={`${
                        isSameAirport
                          ? ' bg-gray text-third cursor-not-allowed'
                          : 'local-airport-items'
                      } pt-1 default-border-radius-xsmall col-8 p-0 d-flex flex-column align-items-center justify-content-center`}
                    >
                      <img
                        src={require(`../../../../content/images/elements/airports/airport-${item.iata}.png`)}
                        alt="airports"
                        className="rounded-circle img-fluid border border-primary-light"
                        style={{ width: '2rem', height: '2rem' }}
                      />
                      <span
                        className={`city-title font-weight-bold font-smaller font-lg-small text-nowrap`}
                      >
                        {item.name[name]}
                      </span>
                    </div>
                  </div>
                </li>
              );
            })}
        </ul>
      );
  };
  checkCurrentCity = (type) => {
    let { index } = this.props;
    let airPortLocalStroage = JSON.parse(
      sessionStorage.getItem('selectedAirport'),
    );
    airPortLocalStroage.map((i, key) => {
      if (i.origin.city == undefined) {
        airPortLocalStroage[key].origin = '';
        type == 'from' &&
          key == index &&
          this.setState({ from: '', isLocal: true });
      }
      if (i.destination.city == undefined) {
        airPortLocalStroage[key].destination = '';
        type == 'to' &&
          key == index &&
          this.setState({ to: '', isLocal: true });
      }
    });
    sessionStorage.setItem(
      'selectedAirport',
      JSON.stringify(airPortLocalStroage),
    );
  };
  renderAirport = (label, type, placeholder) => {
    let {
      flightType,
      index,
      deleteAirPort,
      intl,
      language: { direction },
    } = this.props;
    let { isFocused, isHovered, isFocusedTo, isHoveredTo } = this.state;
    let placeholderMessage = intl.formatMessage({ id: placeholder });

    return (
      <div
        className={`w-100
      ${
        flightType == 'multicity'
          ? type == 'from'
            ? direction == 'rtl'
              ? 'pl-1 pl-sm-2'
              : 'pr-1 pr-sm-2'
            : direction == 'rtl'
            ? 'pr-1 pr-sm-2'
            : 'pl-1 pl-sm-2'
          : ''
      } 
      `}
      >
        <div
          className={`${
            flightType == 'multicity' ? '' : 'position-relative'
          } default-border-radius-xsmall w-100 `}
        >
          <div
            className={`bg-white d-flex align-content-center  border-third w-100 ${
              flightType == 'multicity'
                ? 'font-xsmall font-md-xsmall font-xxl-msmall'
                : 'font-smaller font-sm-normal font-xs-msmall  font-md-smaller font-lg-msmall font-xl-small font-xxl-small'
            }  
          default-border-radius-xsmall p-2 ${
            flightType == 'multicity' ? '' : 'py-lg-2 py-xl-3'
          }  border
        cursor-pointer
        `}
            onMouseLeave={() => {
              this.checkCurrentCity(type);

              this.setState({
                isFocused: false,
                isHovered: false,
                isFocusedTo: false,
                isHoveredTo: false,
              });
            }}
            onClick={(event) => {
              event.stopPropagation();
              this.selectCurrentInput(event.target);
              type === 'from'
                ? this.toggleSelect(true, type)
                : this.toggleSelectTo(true, type);
            }}
            style={{ border: '1px solid transparent' }}
          >
            <div
              className={`d-flex align-items-center align-content-center w-100
              ${
                (type === 'from' && (isFocused || isHovered)) ||
                (type === 'to' && (isFocusedTo || isHoveredTo))
                  ? 'border-bottom-radius'
                  : ''
              }`}
            >
              <LocationIcon
                color="#6c757d"
                size={flightType == 'multicity' ? 16 : 24}
              />
              <div
                className={`eyebrow-note align-items-start ${
                  flightType == 'multicity'
                    ? direction == 'rtl'
                      ? 'pr-1 '
                      : 'pl-1'
                    : 'px-2 px-lg-3 py-md-1 py-lg-0'
                } flex-column p-0 m-0 d-flex justify-content-center w-100`}
              >
                {this.renderInternationalAirportInput(
                  label,
                  type,
                  placeholderMessage,
                )}
              </div>
              <span
                className={`transition-all ${
                  (type === 'from' && (isFocused || isHovered)) ||
                  (type === 'to' && (isFocusedTo || isHoveredTo))
                    ? 'rotate-180deg'
                    : ''
                }`}
              >
                <ChevronDownIcon
                  size={flightType === 'multicity' ? 24 : 32}
                  color="#6c757d"
                />
              </span>
            </div>
            {/* render list of airport  */}
            {this.renderList(type)}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { flightType, deleteAirPort, index, language, intl } = this.props;
    const { openToast } = this.state;
    return (
      <div
        className={`select-airport d-flex  px-sm-2  ${
          flightType == 'multicity'
            ? ' pb-1 pb-md-2 '
            : `flex-column py-sm-2 py-md-5 py-lg-3  h-100 position-relative`
        } 
        ${index == 0 && flightType == 'multicity' ? 'pt-sm-2 pt-md-3' : ''}
       `}
      >
        <Toast
          isOpen={openToast}
          onClose={() => this.setState({ openToast: false })}
          state={'danger'}
          position="bottom"
          message={intl.formatMessage({
            id: 'booking.sameairport',
          })}
          direction={language.direction}
        />
        {flightType == 'multicity' ? (
          <div
            onClick={() => deleteAirPort(index)}
            className={`d-flex align-items-center justify-content-center cursor-pointer ${
              language.direction == 'rtl' ? 'pl-2' : 'pr-2'
            } ${index == 0 && 'invisible'}`}
          >
            <CloseIcon color="#dc2633" size={12} />
          </div>
        ) : (
          ''
        )}

        {/* origin option list */}
        <div
          className={`d-flex flex-fill position-relative ${
            flightType == 'multicity'
              ? ''
              : 'flex-column justify-content-between'
          }`}
        >
          {this.renderAirport('booking.from', 'from', 'booking.originCity')}
          {/* swap icon */}
          {flightType != 'multicity' ? (
            <div
              className={`d-flex justify-content-start align-items-center my-2 my-sm-0 p-0 w-100 px-2 p-sm-${
                language.direction == 'rtl' ? '2' : '3'
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                className={`d-flex align-items-center flex-column position-absolute swap-city ${language.direction}`}
              >
                <div
                  className={`w-100 flex-fill d-flex justify-content-${
                    language.direction == 'rtl' ? 'end' : 'start'
                  } `}
                >
                  <div
                    className="border-third w-50 h-100"
                    style={{
                      borderStyle: 'dashed',
                      borderWidth: '2px 2px 0 0',
                    }}
                  ></div>
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => this.changeAirport()}
                >
                  <SyncIcon color="#6c757d" />
                </div>

                <div
                  className={`w-100 flex-fill d-flex justify-content-${
                    language.direction == 'rtl' ? 'end' : 'start'
                  }`}
                >
                  <div
                    className="border-third w-50 h-100"
                    style={{
                      borderStyle: 'dashed',
                      borderWidth: '0 2px 2px 0',
                    }}
                  ></div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          {/* destination option list */}
          {this.renderAirport('booking.to', 'to', 'booking.destinationCity')}
        </div>
      </div>
    );
  }
  //#endregion
}
function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(injectIntl(SelectAirport));
